const Navigation = [
  {
    id: 0,
    name: "Browse",
    path: "/"
  },
  // {
  //   id: 1,
  //   name: "Categories",
  //   path: "/categories"
  // },
  {
    id: 2,
    name: "Discord",
    path: "https://discord.gg/4ExHy4cGXa"
  }
];

export default Navigation;
